/**
 * Decide se a notificação está não lida.
 * @param {{ readAt?: string|null, status?: string } | null | undefined} item
 * @returns {boolean}
 */
export function isUnreadNotification(item) {
  if (!item) return false;
  if (item.status === "read") return false;
  if (typeof item.readAt === "string" && item.readAt.trim()) return false;
  return true;
}

/** Conta notificações não lidas da lista. */
export function countUnreadNotifications(notifications) {
  if (!Array.isArray(notifications)) return 0;
  return notifications.filter(isUnreadNotification).length;
}
